import { GET_LIST, GET_ONE, GET_MANY, GET_MANY_REFERENCE } from 'react-admin';

import { ResourceDefinition, ResourceSections } from 'src/types';

export const OrganizationCriteriaGroupsResource: ResourceDefinition = {
  name: 'organization_criteria_groups',
  section: ResourceSections.PORTAL,

  extension: {
    operations: {
      [GET_LIST]: {
        operationName: 'portal_organization_criteria_groups',
      },
      [GET_ONE]: {
        operationName: 'portal_organization_criteria_groups',
      },
      [GET_MANY]: {
        operationName: 'portal_organization_criteria_groups',
      },
      [GET_MANY_REFERENCE]: {
        operationName: 'portal_organization_criteria_groups',
      },
    },
  },
};
